export default __webpack_public_path__ + "static/media/message_success.9b766495.svg";